<template>
    <div class="page">
        <div class="header">
            <Header :current="['zt']"></Header>
            <div class="zt-title">商河县主体名录库</div>
            <div class="header-search">
                <a-input-search
                    placeholder="输入搜索内容"
                />
            </div>
        </div>
        <div class="content">
            <div class="complete" v-if="registerStatus">
                <h1>申报信息提交成功！</h1>
                <p style="text-align: center; margin-top: 30px;margin-bottom: 45px">您的系统账号：133222333，密码：123456</p>
                <p>使用以上账号即可登录系统查看您的申报审批进度，申报审批通过后，即可在系统
                    中发布信息，请妥善保管您的系统账号！</p>
            </div>
            <a-form v-else :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules" ref="formRef">
                <div class="mla-form">
                    <div class="mla-form-title"><p>基本信息</p><div></div></div>
                    <a-form-item label="联系人" name="contactsName">
                        <a-input v-model:value="formState.contactsName"  placeholder="请输入联系人姓名"/>
                    </a-form-item>
                    <a-form-item label="所在镇街" name="TownType">
                        <a-select v-model:value="formState.TownType" placeholder="请选择所在镇街">
                            <a-select-option value="5169">孙集镇</a-select-option>
                            <a-select-option value="6148">经济开发区</a-select-option>
                            <a-select-option value="5172">张坊镇</a-select-option>
                            <a-select-option value="5165">郑路镇</a-select-option>
                            <a-select-option value="5170">韩庙镇</a-select-option>
                            <a-select-option value="5162">殷巷镇</a-select-option>
                            <a-select-option value="5167">玉皇庙镇</a-select-option>
                            <a-select-option value="5163">怀仁镇</a-select-option>
                            <a-select-option value="5164">龙桑寺镇</a-select-option>
                            <a-select-option value="6048">许商街道</a-select-option>
                            <a-select-option value="5166">贾庄镇</a-select-option>
                            <a-select-option value="5171">沙河镇</a-select-option>
                            <a-select-option value="5168">白桥镇</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="所在社区" name="address">
                        <a-input v-model:value="formState.address"  placeholder="请输入所在村居或社区"/>
                    </a-form-item>
                    <a-form-item label="联系电话" name="phoneCode">
                        <a-input v-model:value="formState.contactsPhone"  placeholder="请输入联系电话" style="margin-bottom: 10px"/>
                        <a-input v-model:value="formState.phoneCode" @blur="blurCode(formState.phoneCode)" style="width: 180px"  placeholder="验证码"/>
                        <div @click="changeCode()" style="width: 180px"><Code :identifyCode="identifyCode"/></div>
                    </a-form-item>
                </div>
                <a-form-item :wrapper-col="{offset: 11 }">
                    <a-button disabled type="primary" @click="onSubmit" size="large" class="cus-button">提交申请</a-button>
                </a-form-item>
            </a-form>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/portal/Header'
import Footer from "../../components/portal/Footer"
import { reactive } from 'vue'
import { ref } from "@vue/runtime-dom"
import {addDirectories} from "@/api/directories"
import {notification} from "ant-design-vue"
import Code from '@/components/SIdentify'
export default{
    name: "farmerRegister",
    data() {
        return {
            identifyCode: "",
            registerStatus: false
        }
    },
    setup() {
        const loading = reactive({
            codeLoading: false,
            codeText: '发送验证码',
            isCode: false
        })
        const formRef = ref()
        const formState = reactive({
            contactsName: undefined,
            TownType: undefined,
            address: undefined,
            contactsPhone: undefined,
            phoneCode: undefined,
        })
        const checkPhone = (phone) =>{
            if(!(/^1[3456789]\d{9}$/.test(phone))){
                return false
            } else {
                return true
            }
        }
        const rules = {
            contactsName: [{required: true,message: '请输入联系人',trigger: 'blur'}],
            TownType: [
                {
                    required: true,
                    message: '请选择所在镇街',
                    trigger: 'blur',
                },
            ],
            address: [{required: true,message: '请输入所在社区/村',trigger: 'blur'}],
            phoneCode: [{required: true,message: '请输入验证码',trigger: 'blur'}],
            businessLicense: [{required: false,message: '请选择',trigger: 'blur'}],
        }
        const register = async(params) => {
            const data = await addDirectories(params)
            if (data) {
                this.registerStatus = true
                notification.success({ message: '提交成功！', duration: 2.5, description: '' })
                setTimeout(() => {
                    location.reload()
                }, 2000)
            }
        }
        const onSubmit = () => {
            // 要验证loading.isCode是否为true
            formRef.value
                .validate()
                .then(() => {
                    const params = {
                        contactsName: formState.contactsName, //联系人姓名
                        towns: formState.TownType, //所属乡镇
                        address: formState.address, //所在地址
                        contactsPhone: formState.contactsPhone, //联系人电话,
                        verCode: formState.phoneCode, // 验证码
                    }
                    register(params)
                })
                .catch(error => {
                    console.log('error', error);
                })

        }
        return {
            labelCol: {
                span: 5
            },
            wrapperCol: {
                span: 16,
                offset: 1
            },
            formState,
            loading,
            rules,
            formRef,
            onSubmit,
            checkPhone,
            register,
        }
    },
    mounted() {
        this.changeCode()
    },
    methods: {
        changeCode(){
            const index1 = Math.round(Math.random() * (60));
            const index2 = Math.round(Math.random() * (60));
            const index3 = Math.round(Math.random() * (60));
            const index4 = Math.round(Math.random() * (60));
            const  arr = "0123456789qwertyuiopasdfghjklzxcvbnmQAZWSXEDCRFVBGTYHNMJUIKOL";
            const code1=arr.substring(index1,index1+1);
            const code2=arr.substring(index2,index2+1);
            const code3=arr.substring(index3,index3+1);
            const code4=arr.substring(index4,index4+1);
            this.identifyCode=code1+""+code2+""+code3+""+code4;
        },
        blurCode(val){
            if(val.length>0){
                if(val.toLowerCase()!=this.identifyCode.toLowerCase()){
                    notification.error({ message: '验证码输入错误,请核对后重新输入', duration: 1.5, description: '' })
                    this.changeCode();//刷新验证码
                    return
                }
            }
        }
    },
    components: {
        Header,
        Footer,
        Code
    }
}
</script>

<style scoped lang="stylus">
.page {
    width 100%
    height 100%
    position relative
    font-size 16px
    background-color #FFF
    .header {
        width 100%
        height 730px
        padding-top 130px
        box-shadow 0 23px 120px rgba(0, 0, 0, 0.3)
        border-bottom-left-radius 315px
        border-bottom-right-radius 315px
        background-image url("../../assets/img/portal_service_bg.png")
        background-size 100% 100%
        background-repeat no-repeat
        .zt-title {
            margin-top 200px
            width 100%
            font-size 48px
            color #FFF
            font-weight bold
            text-align center
        }
        .header-search {
            width 600px
            height 70px
            margin 60px auto 200px auto
        }
        .header-search >>> .ant-input-affix-wrapper {
            height 70px
            font-size 22px
        }
        .header-search >>> .ant-input-affix-wrapper > input.ant-input {
            border-radius 5.333vw
            font-size 18px
            padding 4px 20px
        }
        .header-search >>> .ant-input-affix-wrapper .ant-input-suffix {
            margin-right 10px
        }
    }
    .content {
        width 100%
        min-height 200px
        margin-top 40px
        padding-bottom 50px
        .complete {
            width 1320px
            padding 40px 50px 110px 50px
            box-shadow 0 9px 28px rgba(0, 0, 0, 0.05)
            background-color #FFF
            margin 0 auto
            margin-bottom 50px
        }
        .complete h1 {
            font-size 46px
            text-align center
        }
        .complete p {
            font-size 35px
            color #9C9C9C
        }
        .mla-form {
            background #FCFCFC
            box-shadow 0 9px 50px rgba(0, 0, 0, 0.05)
            width calc(100% - 160px)
            margin 0 auto
            padding-left 85px
            padding-top 65px
            padding-right 45px
            padding-bottom 45px
            margin-bottom 35px
            .mla-form-title {
                width 100%
                font-size 36px
                color #167ADA
                position relative
                display flex
                justify-content space-between
                margin-bottom 50px
            }
            .mla-form-title div {
                width calc(100% - 210px)
                height 30px
                border-bottom 1px solid #707070
            }
            .code-button {
                height 50px
                line-height 50px
                font-size 22px
                margin-left 10px
            }
            .iframe-style {
                width 100%
                height 0
            }
            .iframe-style-large {
                width 100%
                height 500px
            }
        }
        .cus-button {
            width 370px
            height 80px
            line-height 75px
            font-size 36px
            border-radius 35px
        }
        .mla-form >>> .ant-form-item-label > label {
            font-size 28px
            color #000
        }
        .mla-form >>> .ant-input {
            height 50px
            line-height 50px
            font-size 22px
        }
        .mla-form >>> .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
            height 50px
            line-height 50px
            font-size 22px
            padding 8px 11px
        }
        .mla-form >>> .ant-form-item-label {
            line-height 50px
        }
    }
}
</style>